<template>
  <transition name="fade">
    <div class="modal-custom"> <!--v-if="show"-->
        <div class="modal-custom__backdrop" @click="exitModal"/>

        <div class="modal-custom__dialog" :class="width ? width : 'w-1/3'">
            <div :class="styleClass ? styleClass : 'text-gray-500'" class="modal-custom__header">
                <slot name="header"/>
            </div>

            <div class="modal-custom__body">
                <slot name="body"/>
            </div>

            <div class="modal-custom__footer">
                <slot name="footer"/>
            </div>
        </div>
    </div>
  </transition>
</template>

<script>
export default {
    name: 'Modal',
    props : {
        width : {
            type : String,
            required : false
        },
        styleClass : {
            type : String,
            required : false
        },
        title : {
            type : String,
            required: true
        },
        backdropOff : {
            type : Boolean,
            require : false,
        },
        close : {
            type : Boolean,
            required: false
        }
    },
    data () {
        return {
            show: false
        }
    },
    methods: {
        exitModal () {
            if (!this.backdropOff) {
                this.$emit('handleClose')
            }
        },
        closeModal () {
            this.show = false
            document.querySelector('body').classList.remove('overflow-hidden')
        },
        openModal () {
            this.show = true
            document.querySelector('body').classList.add('overflow-hidden')
        }
    }
}
</script>


<style lang="scss">
.modal-custom {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99999;
  overflow-x: hidden;
  overflow-y: auto;
  &__backdrop {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: .5;
    background: #000;
    z-index: 1;
  }
  &__dialog {
    position: relative;
    // width: 600px;
    background-color: #fff;
    border-radius: 5px;
    margin: 100px auto;
    display: flex;
    flex-direction: column;
    z-index: 999999999 !important;
    @media screen and (max-width: 992px) {
      // width: 90%;
    }
  }
  &__close {
    width: 30px;
    height: 30px;
  }
  &__header {
    // display: flex;
    // align-items: flex-start;
    // justify-content: space-between;
    // padding: 20px 20px 10px;
  }
  &__body {
    padding: 10px 20px 10px;
    // overflow: auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }
  &__footer {
    padding: 10px 20px 20px;
  }
}
.sticky-border{
    border-color: rgba(182, 159, 78, 0.38);
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
